import { BUSINESS_TYPE } from 'src/utils/constants/AppConstants';

import { getPageName, mixpanelObject } from './analytics';
import {
  contentPropertySetter,
  contentBillingType,
  ThumbnailClickEvent,
  viewMoreSelectedEvent
} from './analytics/mixpanel/mixpanelEventsHelper';
import { checkIfEduauraa } from './common';
import { premiumConstants } from './constants/stringConstants';
import { ContentMetaData } from './ConsumptionHelper/types';
import { CardDetailsType } from '../components/thumbnail/types';
import {
  MIXPANEL_SVOD,
  MIXPANEL_AVOD,
  MIXPANEL_BANNER_OR_RAIL,
  MIXPANEL_RAIL,
  MIXPANEL_AVOD_OR_SVOD_CONTENT,
  MIXPANEL_CONTENT,
  MIXPANEL_CONTENT_TYPE,
  MIXPANEL_CONTENT_SPECIFICATION,
  MIXPANEL_PAGE_NAME,
  MIXPANEL_EPISODE_NO,
  MIXPANEL_SOURCE,
  MIXPANEL_IMAGE_URL,
  MIXPANEL_IS_EDUAURAA,
  MIXPANEL_IS_RENTAL,
  MIXPANEL_ELEMENT,
  MIXPANEL_LANDING_PAGE_NAME,
  MIXPANEL_VERTICAL_INDEX,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_CAROUSAL_ID,
  MIXPANEL_CAROUSAL_NAME
} from './analytics/mixpanel/mixpanelConstants';

export const triggerMixpanelForThumbnailClick = (
  contentData: ContentMetaData,
  cardDetails: CardDetailsType,
  imageUrl: string
) => {
  contentPropertySetter(mixpanelObject, contentData, cardDetails);
  const pageName = getPageName(window.location.pathname);
  const contentBusinessType =
    contentData?.business_type || contentData?.businessType || '';
  let userContentType = 'N/A';
  if (
    contentBusinessType === premiumConstants.premium ||
    contentBusinessType === premiumConstants.premiumDownloadable
  ) {
    userContentType = MIXPANEL_SVOD;
  } else {
    userContentType = MIXPANEL_AVOD;
  }
  mixpanelObject[MIXPANEL_BANNER_OR_RAIL] = MIXPANEL_RAIL;
  mixpanelObject[
    MIXPANEL_AVOD_OR_SVOD_CONTENT
  ] = `${userContentType} ${MIXPANEL_CONTENT}`;
  mixpanelObject[MIXPANEL_CONTENT_TYPE] = contentBusinessType;
  mixpanelObject[MIXPANEL_CONTENT_SPECIFICATION] = cardDetails?.assetSubtype;
  mixpanelObject[MIXPANEL_PAGE_NAME] = pageName;
  mixpanelObject[MIXPANEL_EPISODE_NO] = contentData?.episodeNumber;
  mixpanelObject[MIXPANEL_SOURCE] = pageName;
  mixpanelObject[MIXPANEL_IMAGE_URL] = imageUrl || 'N/A';
  mixpanelObject[MIXPANEL_IS_EDUAURAA] =
    contentData && checkIfEduauraa(contentData);
  if (
    contentData.businessType &&
    contentData.billingType &&
    contentBillingType(contentData.businessType, contentData.billingType) ===
      BUSINESS_TYPE.TVOD
  ) {
    mixpanelObject[MIXPANEL_IS_RENTAL] = true;
  }
  ThumbnailClickEvent();
};

export const mixpanelForMoreLinkClick = (
  trayDetails: any,
  verticalIndex: number,
  translations: any,
  railTitle?: string,
  pageName?: string,
  homePageName?: string
) => {
  mixpanelObject[MIXPANEL_ELEMENT] = translations.consumption.MORE;
  mixpanelObject[MIXPANEL_LANDING_PAGE_NAME] = homePageName || 'N/A';
  mixpanelObject[MIXPANEL_PAGE_NAME] = pageName || 'N/A';
  mixpanelObject[MIXPANEL_VERTICAL_INDEX] = verticalIndex || 'N/A';
  mixpanelObject[MIXPANEL_HORIZONTAL_INDEX] = 'N/A';
  mixpanelObject[MIXPANEL_CAROUSAL_ID] =
    trayDetails[0]?.contentId || trayDetails[0]?.id || 'N/A';
  mixpanelObject[MIXPANEL_CAROUSAL_NAME] =
    railTitle || trayDetails.title || 'N/A';
  viewMoreSelectedEvent();
  // mixpanel events ends
};
